import React, { PropTypes } from 'react';
import styles from './VirtualTable.css';

const SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};
/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
export default function SortIndicator({ sortDirection }) {
  let stylesDir = styles.sortableHeaderIconDESC;
  if (sortDirection === '') {
    return (
      <svg
        className={stylesDir}
        viewBox={'0 0 24 24'}
      >
        <path d={'M7 16l5-5 5 5z'} fill={'#808080'} />
        <path d={'M7 18l5 5 5-5z'} fill={'#808080'} />
      </svg>
    );
  }
  if (SortDirection.ASC) {
    stylesDir = styles.sortableHeaderIconASC;
  }
  return (
    <svg
      className={stylesDir}
      viewBox={'0 0 24 24'}
    >
      <path d={'M7 16l5-5 5 5z'} />
      <path d={'M7 18l5 5 5-5z'} />
      {sortDirection === SortDirection.ASC
        ? <path d={'M7 16l5-5 5 5z'} fill={'#808080'} />
        : <path d={'M7 18l5 5 5-5z'} fill={'#808080'} />
      }
    </svg>
  );
}

SortIndicator.propTypes = {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
};



// WEBPACK FOOTER //
// ./src/containers/VirtualTable/SortIndicator.js